import { TranslateService } from '@ngx-translate/core';

import {
    ColumnConfigItem,
    Icon,
} from '../../../frontline-winning/model/fl-winning.global.model';
import { SortOrder } from '../../grid';
import { TranslationKeyMap } from '../commitment-details.i18n';
const textAlign = 'text-align';
const headersContent = 'headers-content';
export function getColumnConfigItemsConfig(
    tls: TranslateService,
): ColumnConfigItem[] {
    return [
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap.__DIRECT_REPORT),
            colstyle: {
                width: '20rem',
                'max-width': '20rem',
                'min-width': '10rem',
            },
            active: true,
            styles: {},
            class: [],
            headerContentClass: 'header-content-oa',
            cellstyles: {
                [textAlign]: 'left',
            },
            icon: [
                new Icon({
                    class: [
                        'chevron-up',
                        'chevron-down',
                        'unfold-more-horizontal',
                    ],
                    counter: SortOrder.ASC,
                    defaultState: SortOrder.ASC,
                    state: true,
                    action: 'sortByDirectReport',
                    prop: 'directReportSort',
                    actionParams: {},
                }),
            ],
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap.__START_DATE),
            active: true,
            colstyle: {
                width: '10rem',
                'max-width': '10rem',
                'min-width': '5rem',
            },

            icon: [
                new Icon({
                    class: [
                        'chevron-up',
                        'chevron-down',
                        'unfold-more-horizontal',
                    ],
                    counter: SortOrder.ASC,
                    defaultState: SortOrder.ASC,
                    state: true,
                    action: 'sortByStartDate',
                    prop: 'startDateSort',
                    actionParams: {},
                }),
            ],
            class: [],
            headerContentClass: headersContent,
            cellstyles: {
                [textAlign]: 'left',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap.__METRIC),
            active: true,
            colstyle: {
                width: '10rem',
                'max-width': '10rem',
                'min-width': '5rem',
            },
            icon: [
                new Icon({
                    class: [
                        'chevron-up',
                        'chevron-down',
                        'unfold-more-horizontal',
                    ],
                    counter: SortOrder.ASC,
                    defaultState: SortOrder.ASC,
                    state: true,
                    action: 'sortByMetric',
                    prop: 'metricSort',
                    actionParams: {},
                }),
            ],
            class: [],
            headerContentClass: headersContent,
            cellstyles: {
                [textAlign]: 'left',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap.__FOCUS),
            active: true,
            colstyle: {
                width: '17rem',
                'max-width': '17rem',
                'min-width': '5rem',
            },
            class: [],
            headerContentClass: 'headers-content',
            cellstyles: {
                [textAlign]: 'left',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap.__START_ACTUAL),
            active: true,
            colstyle: { width: '10%' },
            styles: {
                width: '10%',
                'min-width': '7.5rem',
                'max-width': '7.5rem',
            },
            class: [],
            headerContentClass: 'headers-content',
            cellstyles: {
                [textAlign]: 'left',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap.__ASSESSED_ACTUAL),
            active: true,
            colstyle: { width: '10%' },
            styles: {
                width: '10%',
                'min-width': '7.5rem',
                'max-width': '7.5rem',
            },
            class: [],
            headerContentClass: 'headers-content',
            cellstyles: {
                [textAlign]: 'left',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap.____IMPROVEMENT),
            active: true,
            colstyle: { width: '10%' },
            styles: {
                width: '10%',
                'min-width': '7.5rem',
                'max-width': '7.5rem',
            },
            class: [],
            headerContentClass: 'headers-content',
            cellstyles: {
                [textAlign]: 'left',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap.__STATE),
            active: true,
            colstyle: { width: '10%' },
            styles: {
                width: '10%',
                'min-width': '7.5rem',
                'max-width': '7.5rem',
            },
            class: [],
            headerContentClass: 'headers-content',
            cellstyles: {
                [textAlign]: 'left',
            },
        }),
        new ColumnConfigItem({
            header: tls.instant(TranslationKeyMap.__WINS_AT),
            active: true,
            colstyle: { width: '10%' },
            styles: {
                width: '10%',
                'min-width': '7.5rem',
                'max-width': '7.5rem',
            },
            class: [],
            headerContentClass: 'headers-content',
            cellstyles: {
                [textAlign]: 'center',
            },
        }),
        new ColumnConfigItem({
            header: '  ',
            active: true,
            colstyle: { width: '10%' },
            styles: {
                width: '10%',
                'min-width': '7.5rem',
                'max-width': '7.5rem',
            },
            class: [],
            headerContentClass: 'headers-content',
            cellstyles: {
                [textAlign]: 'left',
            },
        }),
    ];
}
